import type { RestEndpointQueryArgs } from '@src/providers/AppStateProvider/restEndpointBaseQuery';
import { baseRestApi } from '@src/utils/rtkQuery';
import { logger } from '@talos/kyoko';

export type Timezone = {
  Name: string;
};

export function warnIfBrowserTimezoneUnsupported(
  timezones: Timezone[],
  browserTimezone: string,
  warn: typeof logger.warn = logger.warn
): void {
  if (!timezones.some(timezone => timezone.Name === browserTimezone)) {
    warn('Browser timezone is not supported by Ava', {
      extra: { browserTimezone },
    });
  }
}

export function getAvaTimezonesQuery(): RestEndpointQueryArgs {
  return {
    method: 'GET',
    url: '/calendars/timezones',
    // IANA catalog is ~550; limit keeps the common case to one request (API default is 500).
    // paginateRecords covers growth past a single page.
    params: { limit: 2000 },
    paginateRecords: 10_000,
  };
}

const avaTimezonesApi = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    avaTimezones: builder.query<Timezone[], void>({
      query: getAvaTimezonesQuery,
      serializeQueryArgs: () => 'ava-timezones',
      transformResponse: (timezones: Timezone[]) => {
        warnIfBrowserTimezoneUnsupported(timezones, Intl.DateTimeFormat().resolvedOptions().timeZone);
        return timezones;
      },
    }),
  }),
});

export const { useAvaTimezonesQuery } = avaTimezonesApi;

/** Alias kept for existing call sites. */
export const useTimezonesQuery = useAvaTimezonesQuery;
